document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.pdp-gallery-embla');
  if (!root) return;

  /* -----------------------------
      Main gallery
  ----------------------------- */
  const mainViewport = root.querySelector('.pdp-gallery-embla__viewport');
  const prevBtn = root.querySelector('.pdp-gallery-embla__button--prev');
  const nextBtn = root.querySelector('.pdp-gallery-embla__button--next');
  const progressBar = root.querySelector('.pdp-gallery-embla__progress-bar');

  const emblaMain = EmblaCarousel(
    mainViewport,
    { loop: false },
    [EmblaCarouselAutoHeight()]
  );

  // Function to update button classes
  const updateButtonClasses = () => {
    if (!prevBtn || !nextBtn) return;
    prevBtn.classList.toggle('m-button--disabled', !emblaMain.canScrollPrev());
    nextBtn.classList.toggle('m-button--disabled', !emblaMain.canScrollNext());
  };

  // Add click events
  prevBtn?.addEventListener('click', () => {
    emblaMain.scrollPrev();
    updateButtonClasses();
  });
  nextBtn?.addEventListener('click', () => {
    emblaMain.scrollNext();
    updateButtonClasses();
  });

  updateButtonClasses();

  /* -----------------------------
      Progress bar
  ----------------------------- */
  const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

  const updateProgress = () => {
    if (!progressBar) return;
    const progress = clamp(emblaMain.scrollProgress(), 0, 1);
    progressBar.style.transform = `translate3d(${progress * 100 - 100}%, 0, 0)`;
  };

  /* -----------------------------
      Sync events
  ----------------------------- */
  emblaMain
    .on('init', () => {
      updateProgress();
      updateButtonClasses();
    })
    .on('select', () => {
      updateProgress();
      updateButtonClasses(); // keep buttons in sync on slide change too
    })
    .on('reInit', () => {
      updateProgress();
      updateButtonClasses();
    })
    .on('scroll', updateProgress);

});
